import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { fuseAnimations } from '@fuse/animations';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Course, Learnspace } from '@shared/models';
import { ProgramReportingSessionLogComponent } from './program-reporting-session-log/program-reporting-session-log.component';
import { AssessmentReportDialogComponent } from '@app/main/analytics/assessment/assessment-report-dialog/assessment-report-dialog.component';
const defaultSection = 'reports';

@Component({
  selector: 'program-reporting',
  templateUrl: './program-reporting.component.html',
  styleUrls: ['./program-reporting.component.scss'],
  animations: fuseAnimations
})
export class ProgramReportingComponent implements OnInit, OnDestroy, OnChanges {
  @Input() learnspace: Learnspace;
  activeCourseId: string = '';
  activeCourse: Course = null;
  activeMode: string = defaultSection;
  private subscription: Subscription;

  constructor(private _courseApiService: CoursesAPIService, private _router: Router, private _route: ActivatedRoute, private _dialog: MatDialog) {}

  async ngOnInit() {
    this.subscription = this._route.queryParams.subscribe(async (params) => {
      await this.updateContent();
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.learnspace) {
      await this.updateContent();
    }
  }

  private async updateContent() {
    this.activeMode = this._route.snapshot.queryParams.section || defaultSection;
    this.activeCourseId = this._route.snapshot.queryParams.simulationId;
    if (this.activeCourseId && this.activeCourseId != this.activeCourse?.id) {
      this.activeCourse = undefined; // This is needed to ensure that the old course is not displayed while waiting for the new one.
      this.activeCourse = await this._courseApiService.getCourseById(this.activeCourseId).toPromise();
    }
    
    if (!this.activeCourseId && this.learnspace?.courses?.length > 0) {
      this.activeCourse = this.learnspace.courses[0];
      this.activeCourseId = this.activeCourse.id;
    }
  }
  
  goToCourse(simulationId: string, section: string = defaultSection) {
    this._router.navigate([], {
      relativeTo: this._route,
      queryParams: { simulationId, section },
      queryParamsHandling: 'merge'
    });
  }

  sortCourses(courses: Course[] | undefined): Course[] {
    return (courses || []).sort((a, b) => {
      return a.position - b.position;
    });
  }

  onOpenSessionLog(event: any) {
    const dialog = this._dialog.open(ProgramReportingSessionLogComponent, {
      width: 'min(80vw, 1200px)',
      maxHeight: 'min(85vh, 800px)',
      panelClass: 'learnspace-theme',
      data: { sessionId: event.sessionId, course: event.course },
      autoFocus: false
    });
    dialog.componentInstance.onExplore.subscribe(event => this.openAssessmentDashboard(event));
  }

  openAssessmentDashboard(event: any) {
    const dialog = this._dialog.open(AssessmentReportDialogComponent, {
      width: 'min(80vw, 1200px)',
      height: 'min(85vh, 800px)',
      panelClass: 'learnspace-theme',
      data: { assessment: event.assessmentResult, course: event.course },
      autoFocus: false
    });
    dialog.componentInstance.onExplore.subscribe(event => this.onOpenSessionLog(event));
  }
}
